<template>
  <div id="app">
      <!-- <router-view v-if="userInfo&&userInfo.token"/> -->
      <router-view />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import * as api_user from "service/api/methods/api_user.js"; //接口

export default {
  name: "home",
  components: {},
  computed: {
    ...mapGetters(["userInfo","menuList"])
  },
  data() {
    return {};
  },
  created() {
    // this.$utils.initRem(document, window);
  },
  mounted() {
    this.$utils.initRem(document, window);
  },
  methods: {
    loadUserInfo() {
      //获取用户信息
      api_user.getTokenUser().then(res => {
          this.getMenus();
          this.$constant.downloadUrl =this.$constant.httpUrl.downloadWorks +"?Authorization=" +this.$storage.getUserInfo().token +"&"; //下载地址
      }).catch(earr => {});
    },
    getMenus(){//用户菜单
      //获取用户菜单
      api_user.getMenus().then(res => {
      }).catch(earr => {});
    }
  }
};
</script>

<style lang="less">
@import url("utils/css/cssreset.css");
@import url("utils/css/general.less");
@import url("utils/css/elementOften.less");
</style>